module.exports = __webpack_public_path__ + "media/images/os_cara/glin-pedro-cd03e2c5538450524edaf8e33204585b.jpg";